module.exports = __webpack_public_path__ + "static/media/logo-letras-negro-small.bf982cea.png";